<template>
  <div class="row">
    <div class="col-12">
      <ibox :title="'Przymierzalnia'">
        <template slot="tools">
          <router-link
            :to="`/przymierzalnia/${$route.params.env}/produkty/dodaj`"
            class="btn btn-primary btn-xs"
          >
            Dodaj nowy Produkt
            <i class="fas fa-plus"></i>
          </router-link>
        </template>
        <template slot="content" slot-scope="{ setLoading }">
          <data-tables
            ref="productsTable"
            :url="`vnfr/${$route.params.env}/products/list`"
            :draggableSort="draggableSort"
            :columns_list="columns_list"
            :rowStyle="rowStyle"
            @loading="setLoading"
            @updateDraggableSort="updateSort"
          />
        </template>
      </ibox>
    </div>
  </div>
</template>

<script>
import Ibox from '@/components/Ibox'
import DataTables from '@/components/DataTables'

export default {
  name: 'ProductsList',
  components: {
    Ibox,
    DataTables
  },
  computed: {
    sortProductsUrl() {
      return `vnfr/${this.$route.params.env}/products/sort`
    }
  },
  data() {
    return {
      excel: true,
      draggableSort: true,
      columns_list: [
        {
          key: 'id',
          name: this.$t( 'edit' ),
          filter: 'btn',
          btn: a =>
            `<a href="#/przymierzalnia/${this.$route.params.env}/produkty/${a}"><i class="fa fa-edit"></i></a>`
        },
        {
          key: 'id',
          name: this.$t( 'clone' ),
          filter: 'btn',
          btn: a =>
            `<a href="#/przymierzalnia/${this.$route.params.env}/produkty/${a}/klonuj"><i class="fa fa-edit"></i></a>`
        },
        {
          key: 'plum',
          name: 'Plum',
          type: 'text',
          sortable: true
        },
        {
          key: 'ean',
          name: 'EAN',
          type: 'text',
          sortable: true
        },
        {
          key: 'name_prefix',
          name: 'Prefix',
          type: 'text',
          sortable: true
        },
        {
          key: 'name',
          name: 'Nazwa',
          type: 'text',
          sortable: true
        },
        {
          key: 'name_suffix',
          name: 'Suffix',
          type: 'text',
          sortable: true
        },
        {
          key: 'image_url',
          name: 'Zdjęcie',
          filter: 'image',
          width: '100'
        },
        {
          key: 'visible',
          name: 'Widoczny',
          type: 'text',
          filter: 'boolean',
          sortable: true
        },
        {
          key: 'visible_pl',
          name: 'Widoczny PL',
          type: 'boolean',
          filter: 'boolean',
          sortable: true
        },
        {
          key: 'visible_en',
          name: 'Widoczny EN',
          type: 'boolean',
          filter: 'boolean',
          sortable: true
        },
        {
          key: 'visible_de',
          name: 'Widoczny DE',
          type: 'boolean',
          filter: 'boolean',
          sortable: true
        },
        {
          key: 'visible_es',
          name: 'Widoczny ES',
          type: 'boolean',
          filter: 'boolean',
          sortable: true
        },
        {
          key: 'visible_it',
          name: 'Widoczny IT',
          type: 'boolean',
          filter: 'boolean',
          sortable: true
        },
        {
          key: 'visible_fr',
          name: 'Widoczny FR',
          type: 'boolean',
          filter: 'boolean',
          sortable: true
        }
      ]
    }
  },
  methods: {
    updateSort( data ) {
      this.$refs.productsTable.$emit( 'loading', true )

      const sortProductsIds = data.map( el => el.id )

      this.$http
        .put( this.sortProductsUrl, {
          sortIds: sortProductsIds
        } )
        .then( resp => {
          console.log( 'resp', resp )
          if ( resp.data.success == true ) {
            this.$toastr.success( this.$t( 'success_save' ) )
          } else {
            this.$toastr.error( this.$t( 'fail_save' ) )
          }
          this.$refs.productsTable.$emit( 'loading', false )
        } )
        .catch( err => {
          this.$toastr.error( err )
          this.$refs.productsTable.$emit( 'loading', false )
        } )
    },
    rowStyle( data ) {
      // if ( data.visible === 1 ) {
      //     return 'background-color: #8fd19e; color: #000;'
      // }

      if ( data.visible === 0 || data.visible === '0' ) {
        return 'background-color: #c4302b; color: #FFFFFF;'
      }
      // if ( data.visible_lang === 1 ) {
      //     return 'background-color: #8fd19e; color: #000;'
      // }

      if (
        ( data.visible_pl === 0 || data.visible_pl === '0' ) &&
        ( data.visible_en === 0 || data.visible_en === '0' ) &&
        ( data.visible_de === 0 || data.visible_de === '0' ) &&
        ( data.visible_it === 0 || data.visible_it === '0' ) &&
        ( data.visible_es === 0 || data.visible_es === '0' ) &&
        ( data.visible_fr === 0 || data.visible_fr === '0' )
      ) {
        return 'background-color: #f8ac59; color: #FFFFFF;'
      }
      return ''
    }
  }
}
</script>
